(function () {
  if (window.__plzGalleryLightboxBooted) return;
  window.__plzGalleryLightboxBooted = true;

  var lightboxEl = null;
  var lightboxImage = null;
  var lightboxCounter = null;
  var activeGallery = null;
  var activeItems = [];
  var activeIndex = 0;
  var lastFocus = null;

  function ensureLightbox() {
    if (lightboxEl) return lightboxEl;

    lightboxEl = document.createElement('div');
    lightboxEl.className = 'plz-gallery-lightbox';
    lightboxEl.hidden = true;
    lightboxEl.innerHTML =
      '<div class="plz-gallery-lightbox__backdrop" data-plz-gallery-close tabindex="-1"></div>' +
      '<div class="plz-gallery-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Product image">' +
      '<button type="button" class="plz-gallery-lightbox__close" data-plz-gallery-close aria-label="Close">' +
      '<span aria-hidden="true">&times;</span></button>' +
      '<figure class="plz-gallery-lightbox__figure">' +
      '<button type="button" class="plz-gallery-lightbox__nav plz-gallery-lightbox__nav--prev" data-plz-gallery-prev aria-label="Previous image">' +
      '<span aria-hidden="true">&lsaquo;</span></button>' +
      '<img class="plz-gallery-lightbox__image" alt="">' +
      '<button type="button" class="plz-gallery-lightbox__nav plz-gallery-lightbox__nav--next" data-plz-gallery-next aria-label="Next image">' +
      '<span aria-hidden="true">&rsaquo;</span></button>' +
      '</figure>' +
      '<p class="plz-gallery-lightbox__counter" aria-live="polite"></p>' +
      '</div>';

    document.body.appendChild(lightboxEl);

    lightboxImage = lightboxEl.querySelector('.plz-gallery-lightbox__image');
    lightboxCounter = lightboxEl.querySelector('.plz-gallery-lightbox__counter');

    lightboxEl.querySelectorAll('[data-plz-gallery-close]').forEach(function (node) {
      node.addEventListener('click', closeLightbox);
    });

    lightboxEl.querySelector('[data-plz-gallery-prev]').addEventListener('click', function () {
      showSlide(activeIndex - 1);
    });

    lightboxEl.querySelector('[data-plz-gallery-next]').addEventListener('click', function () {
      showSlide(activeIndex + 1);
    });

    document.addEventListener('keydown', onKeydown);

    return lightboxEl;
  }

  function getGalleryItems(gallery) {
    var items = [];
    var seen = {};

    gallery.querySelectorAll('[data-plz-gallery-open]').forEach(function (btn) {
      var index = btn.getAttribute('data-plz-gallery-index');
      if (index == null || seen[index]) return;

      seen[index] = true;
      items.push({
        index: parseInt(index, 10),
        src: btn.getAttribute('data-plz-gallery-src'),
        alt: btn.getAttribute('data-plz-gallery-alt') || '',
      });
    });

    items.sort(function (a, b) {
      return a.index - b.index;
    });

    return items;
  }

  function updateNavState() {
    var prev = lightboxEl.querySelector('[data-plz-gallery-prev]');
    var next = lightboxEl.querySelector('[data-plz-gallery-next]');
    var hasMany = activeItems.length > 1;

    prev.hidden = !hasMany;
    next.hidden = !hasMany;
    lightboxCounter.hidden = !hasMany;

    if (hasMany) {
      lightboxCounter.textContent = activeIndex + 1 + ' / ' + activeItems.length;
    }
  }

  function showSlide(index) {
    if (!activeItems.length) return;

    if (index < 0) index = activeItems.length - 1;
    if (index >= activeItems.length) index = 0;

    activeIndex = index;
    var item = activeItems[activeIndex];

    lightboxImage.src = item.src;
    lightboxImage.alt = item.alt;
    updateNavState();
  }

  function openLightbox(gallery, index) {
    activeGallery = gallery;
    activeItems = getGalleryItems(gallery);
    if (!activeItems.length) return;

    var startIndex = 0;
    if (typeof index === 'number' && !isNaN(index)) {
      startIndex = activeItems.findIndex(function (item) {
        return item.index === index;
      });
      if (startIndex < 0) startIndex = 0;
    }

    ensureLightbox();
    lastFocus = document.activeElement;
    showSlide(startIndex);

    lightboxEl.hidden = false;
    document.body.classList.add('plz-gallery-lightbox-open');
    lightboxEl.classList.remove('is-opening');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        lightboxEl.classList.add('is-opening');
      });
    });
    lightboxEl.querySelector('.plz-gallery-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightboxEl || lightboxEl.hidden) return;

    lightboxEl.classList.remove('is-opening');
    lightboxEl.hidden = true;
    lightboxImage.removeAttribute('src');
    document.body.classList.remove('plz-gallery-lightbox-open');
    activeGallery = null;
    activeItems = [];
    activeIndex = 0;

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function onKeydown(event) {
    if (!lightboxEl || lightboxEl.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeLightbox();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showSlide(activeIndex - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      showSlide(activeIndex + 1);
    }
  }

  function initGalleryLightboxIn(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope
      .querySelectorAll('[data-plz-shop-gallery], [data-plz-gallery-scope]')
      .forEach(function (gallery) {
      if (!gallery.dataset.plzLightboxInit) {
        gallery.dataset.plzLightboxInit = 'true';
      }

      gallery.querySelectorAll('[data-plz-gallery-open]').forEach(function (btn) {
        if (btn.dataset.plzLightboxBtnInit) return;
        btn.dataset.plzLightboxBtnInit = 'true';

        var pointerStartX = 0;
        var pointerStartY = 0;
        var pointerMoved = false;

        btn.addEventListener(
          'pointerdown',
          function (event) {
            pointerStartX = event.clientX;
            pointerStartY = event.clientY;
            pointerMoved = false;
          },
          { passive: true }
        );

        btn.addEventListener(
          'pointermove',
          function (event) {
            if (
              Math.abs(event.clientX - pointerStartX) > 8 ||
              Math.abs(event.clientY - pointerStartY) > 8
            ) {
              pointerMoved = true;
            }
          },
          { passive: true }
        );

        btn.addEventListener('click', function (event) {
          if (pointerMoved) return;
          event.preventDefault();
          event.stopPropagation();
          var index = parseInt(btn.getAttribute('data-plz-gallery-index'), 10);
          openLightbox(gallery, index);
        });
      });
    });
  }

  window.plzGalleryLightboxInit = initGalleryLightboxIn;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGalleryLightboxIn(document);
    });
  } else {
    initGalleryLightboxIn(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGalleryLightboxIn(event.target);
  });
})();
